import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronLeft} from "@fortawesome/free-solid-svg-icons";
import {useNavigate} from 'react-router-dom';

function NavbarBackButton({...props}) {
  let navigate = useNavigate();
  const backButton = () => {
    navigate(-1)
  };
  return (
    <button
        className="back-button"
        onClick={() => backButton()}
    ><FontAwesomeIcon icon={faChevronLeft} /></button>
  );
}
export default NavbarBackButton;
